import { CardBaseComponent } from '@/components/base/card-base/card-base.component';
import { DocSummaryCardComponent } from '@/components/doc-summary-card/doc-summary-card.component';
import { PropertyDocCardComponent } from '@/components/property-doc-card/property-doc-card.component';
import { TooltipDirective } from '@/directives/tooltip/tooltip.directive';
import { DateFormatPipe } from '@/extensions/datePipe';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PropertiesBookletService, PropertyBooklet, PropertyBookletInsulationDetail, RealProperty } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { PropertyBookletInsulationDialogComponent, PropertyBookletInsulationRoofDialogData } from '../property-booklet-insulation-dialog/property-booklet-insulation-dialog.component';
import { PropertyBookletInsulationService } from './property-booklet-insulation.service';

export enum PropertyBookletInsulationType {
  roof = 'roof',
  walls = 'walls',
  floor = 'floor',
  windows = 'windows'
}

@Component({
  selector: 'app-property-booklet-insulation-card',
  standalone: true,
  imports: [
    MatCardModule,
    DateFormatPipe,
    PropertyDocCardComponent,
    NgIf,
    NgTemplateOutlet,
    MatButtonModule,
    MatIconModule,
    TooltipDirective,
    DocSummaryCardComponent,
    CardBaseComponent,
    MatTooltipModule
  ],
  templateUrl: './property-booklet-insulation-card.component.html',
  styleUrl: './property-booklet-insulation-card.component.scss'
})
export class PropertyBookletInsulationCardComponent {

  private readonly propertiesBookletService = inject(PropertiesBookletService);

  @Input({required: true}) booklet: PropertyBooklet;
  @Input({required: true}) prop: RealProperty;
  @Input({required: true}) insulation: PropertyBookletInsulationDetail;
  @Input({required: true}) type: PropertyBookletInsulationType;
  @Output() updated = new EventEmitter<void>();

  title: string;
  summary: string;
  isLoading: boolean;
  sub = new Subscription();

  constructor(private dialog: MatDialog) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['type']) {
      this.setTitle();
      this.setSummary();
    }
  }

  edit() {
    if (this.dialog.openDialogs.length === 0) {
      const data: PropertyBookletInsulationRoofDialogData = {
        prop: this.prop,
        bookletUid: this.booklet.uid,
        bookletType: this.booklet.type,
        type: this.type,
      }
      const dialogRef = this.dialog.open(PropertyBookletInsulationDialogComponent, {
        data
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.updated.emit();
        }
      });
    }
  }

  setTitle() {
    this.title = PropertyBookletInsulationService.getTitle(this.type);
  }

  setSummary() {
    this.summary = PropertyBookletInsulationService.getSummary(this.type);
  }
}
